import { render, staticRenderFns } from "./IconVimeo.vue?vue&type=template&id=bcb02e24&"
import script from "./IconVimeo.vue?vue&type=script&lang=js&"
export * from "./IconVimeo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bcb02e24')) {
      api.createRecord('bcb02e24', component.options)
    } else {
      api.reload('bcb02e24', component.options)
    }
    module.hot.accept("./IconVimeo.vue?vue&type=template&id=bcb02e24&", function () {
      api.rerender('bcb02e24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconVimeo.vue"
export default component.exports